var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataPortal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 21.12,
    viewBox: "0 0 24 21.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_1",
    "data-name": "Union 1",
    d: "M0,19.12a2,2,0,0,1,2-2q.079,0,.156.006L5.573,6.609a2,2,0,1,1,2.949-.658l7.817,8.383a1.991,1.991,0,0,1,.818-.211L20.624,3.451A2,2,0,1,1,22,4a2.019,2.019,0,0,1-.286-.02l-3.4,10.456a2,2,0,1,1-2.839.734L7.661,6.787a1.992,1.992,0,0,1-.9.213H6.708L3.272,17.576A2,2,0,1,1,0,19.12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataPortal);
export default __webpack_public_path__ + "static/media/DataPortal.8085126da025b50dcfb60fd0c665d584.svg";
export { ForwardRef as ReactComponent };